import login from './login';

export default {
  language: 'ja-JP',
  country: 'jp',
  name: '日本語',
  embeddedLocale: login,
};
